// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"mermaid-viewer--codeContainer--1TS3H"};